module.exports = __webpack_public_path__ + "img/Toussarego.af532fd3.jpg";